import type { ReactNode } from 'react';

/**
 * One consistent status pill for the whole console (rebrand PR-B). Monochrome-friendly:
 * a hairline border + a semantic text colour on the paper surface, one size/radius
 * everywhere (Live · Building · Locked · Failed · draft…). Presentation only.
 */
export type ChipTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const TONE: Record<ChipTone, string> = {
  success: 'border-success text-success',
  warning: 'border-warning-bright text-warning',
  danger: 'border-danger text-danger',
  info: 'border-info text-info',
  neutral: 'border-line text-ink-2',
};

export function StatusChip({ tone = 'neutral', children }: { tone?: ChipTone; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded border px-2 py-0.5 text-xs ${TONE[tone]}`}>
      {children}
    </span>
  );
}
